import { render, staticRenderFns } from "./publicHeaderNew.vue?vue&type=template&id=0a88ec97&scoped=true"
import script from "./publicHeaderNew.vue?vue&type=script&lang=js"
export * from "./publicHeaderNew.vue?vue&type=script&lang=js"
import style0 from "./publicHeaderNew.vue?vue&type=style&index=0&id=0a88ec97&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a88ec97",
  null
  
)

export default component.exports